import UploadExcel from "./UploadExcel";
import RollingUpload from './RollingUploadResult';
export const RollingUploadResult = RollingUpload;
export default UploadExcel;